import script from "./invoice-price-tax-dialog.vue?vue&type=script&lang=tsx&setup=true"
export * from "./invoice-price-tax-dialog.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__